import { RedirectUrlType } from '@oy/types';
import { CallbackUrlType } from 'src/models';
import keyMirror from 'src/utilities/keyMirror';

export type DeveloperOptionState = {
  apiContentEncryption: {
    active: boolean;
    lastUpdated?: string | null;
    status: 'loading' | 'error' | 'success' | 'idle';
    key: string;
  };
  callbackUrl: {
    data: CallbackUrlType[];
    status: 'loading' | 'error' | 'success' | 'idle';
    formErrors: Record<string, string>;
  };
  redirectUrl: {
    data: RedirectUrlType[];
    status: 'loading' | 'error' | 'success' | 'idle';
    formErrors: Record<string, string>;
  };
};

export const ACTION_TYPES = keyMirror({
  DEVELOPER_OPTION_GET_API_CONTENT_ENCRYPTION: null,
  DEVELOPER_OPTION_GET_API_CONTENT_ENCRYPTION_SUCCESS: null,
  DEVELOPER_OPTION_GET_API_CONTENT_ENCRYPTION_FAILED: null,
  DEVELOPER_OPTION_API_CONTENT_ENCRYPTION_SET_STATUS: null,

  DEVELOPER_OPTION_GET_CALLBACK_URL: null,
  DEVELOPER_OPTION_GET_CALLBACK_URL_SUCCESS: null,
  DEVELOPER_OPTION_GET_CALLBACK_URL_FAILED: null,

  DEVELOPER_OPTION_SET_CALLBACK_URL: null,
  DEVELOPER_OPTION_SET_CALLBACK_URL_ERROR: null,

  DEVELOPER_OPTION_GET_REDIRECT_URL: null,
  DEVELOPER_OPTION_GET_REDIRECT_URL_SUCCESS: null,
  DEVELOPER_OPTION_GET_REDIRECT_URL_FAILED: null,

  DEVELOPER_OPTION_SET_REDIRECT_URL: null,
  DEVELOPER_OPTION_SET_REDIRECT_URL_ERROR: null,
});
